import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import backMusic, { State } from '@/store/backMusic';
import BackMusicPlayer from '@/views/components/BackMusicPlayer.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import Toast from './Toast.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[backMusic.name])
const backMusicVisible = computed(() => data.value.list.length > 0)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Toast),
    (_unref(backMusicVisible))
      ? (_openBlock(), _createBlock(BackMusicPlayer, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})